import { GetAuditStatsInput } from '@amzn/gbsa-helios-typescript-client';

export const auditStatsKeys = {
  all: ['audit'] as const,
  allStats: ['audit', 'stats'] as const,
  getStats: ({
    businessUnitId,
    auditTypes,
    dateRange,
    divisions,
    locations,
    statuses,
  }: GetAuditStatsInput) =>
    [
      ...auditStatsKeys.allStats,
      businessUnitId,
      auditTypes,
      dateRange,
      divisions,
      locations,
      statuses,
    ] as const,
};
